export default __webpack_public_path__ + "static/media/BlackBerry BlackBerry Priv.421bb1b9.png";